export const modalPortalContainerId = "modal_portal_container";
export const modalAfterBottomModalContainerId = "modal_after_bottom_modal_container";
export const bottomModalPortalContainerId = "bottom_modal_portal_container";
